import React from 'react'
import ToDo from '../components/Todo/ToDo'

export default function Task() {
    return (
        <div className="layout-body">
           <ToDo />
        </div>
    )
}
